import client from '../ApolloClient'
import gql from 'graphql-tag'
import {
  FETCH_PUSH_CONTENT_NOTIFICATIONS,
  FETCH_PUSH_EVENT_NOTIFICATIONS,
  failFetch,
  loadPushNotifications,
  LOAD_PUSH_CONTENT_NOTIFICATIONS,
  LOAD_PUSH_EVENT_NOTIFICATIONS,
  FETCH_PUSH_ALERT_NOTIFICATIONS,
  LOAD_PUSH_ALERT_NOTIFICATIONS,
  FETCH_PUSH_SMS_NOTIFICATIONS,
  LOAD_PUSH_SMS_NOTIFICATIONS
} from '../Actions/Notifications'
// eslint-disable-next-line
import { Observable, Subject, filter, switchMap, map } from 'rxjs'

const pushNotificationQuery = gql`query allPushNotifications($accountId: String!,
      $startDate: DateTime!, $endDate: DateTime!, $limit: Int, $offset: Int, $appProfileIds: [ID!], $groupIds: [ID!], $deviceType: DeviceType!, $pushNotificationType: PushNotificationType!, $sort: String) {
  allPushNotifications (accountId: $accountId, startDate: $startDate, endDate: $endDate, limit: $limit, offset: $offset, appProfileIds: $appProfileIds, groupIds: $groupIds, deviceType: $deviceType, pushNotificationType: $pushNotificationType, sort: $sort) {
    pushNotifications {
      _id
      notificationType
      title
      totalSent
      totalDelivered
      totalFailed
      totalErrored
      totalUndelivered
      createdDate
    }
    count
  }
}`

/**
 * pushNotificationEpic
 * @desc action Observer that sends a query and processes result if the action is a push notification action
 * @param {Observable<action>} action$ Action Observable stream
 * @return {action}
 */
export const pushNotificationEpic = action$ =>
  action$.pipe(
    filter(action => action.type === FETCH_PUSH_CONTENT_NOTIFICATIONS),
    switchMap(action => {
      const subject = new Subject()
      client.query({ query: pushNotificationQuery, variables: action.query })
        .then((data) => { subject.next(data) })
        .catch((error) => {
          subject.next(error)
        })
      return subject.pipe(
        map((response) => {
          if (response.data) {
            return loadPushNotifications(response.data, LOAD_PUSH_CONTENT_NOTIFICATIONS)
          } else {
            return failFetch(response)
          }
        })
      )
    })
  )

/**
 * pushEventNotificationEpic
 * @desc action Observer that sends a query and processes result if the action is a push notification action
 * @param {Observable<action>} action$ Action Observable stream
 * @return {action}
 */
export const pushEventNotificationEpic = action$ =>
  action$.pipe(
    filter(action => action.type === FETCH_PUSH_EVENT_NOTIFICATIONS),
    switchMap(action => {
      const subject = new Subject()
      client.query({ query: pushNotificationQuery, variables: action.query })
        .then((data) => { subject.next(data) })
        .catch((error) => {
          subject.next(error)
        })
      return subject.pipe(
        map((response) => {
          if (response.data) {
            return loadPushNotifications(response.data, LOAD_PUSH_EVENT_NOTIFICATIONS)
          } else {
            return failFetch(response)
          }
        })
      )
    })
  )

/**
 * pushEventNotificationEpic
 * @desc action Observer that sends a query and processes result if the action is a push notification action
 * @param {Observable<action>} action$ Action Observable stream
 * @return {action}
 */
export const pushAlertNotificationEpic = action$ =>
  action$.pipe(
    filter(action => action.type === FETCH_PUSH_ALERT_NOTIFICATIONS),
    switchMap(action => {
      const subject = new Subject()
      client.query({ query: pushNotificationQuery, variables: action.query })
        .then((data) => { subject.next(data) })
        .catch((error) => {
          subject.next(error)
        })
      return subject.pipe(
        map((response) => {
          if (response.data) {
            return loadPushNotifications(response.data, LOAD_PUSH_ALERT_NOTIFICATIONS)
          } else {
            return failFetch(response)
          }
        })
      )
    })
  )

/**
 * pushSmsNotificationEpic
 * @desc action Observer that sends a query and processes result if the action is a push notification action
 * @param {Observable<action>} action$ Action Observable stream
 * @return {action}
 */
export const pushSmsNotificationEpic = action$ =>
  action$.pipe(
    filter(action => action.type === FETCH_PUSH_SMS_NOTIFICATIONS),
    switchMap(action => {
      const subject = new Subject()
      client.query({ query: pushNotificationQuery, variables: action.query })
        .then((data) => { subject.next(data) })
        .catch((error) => {
          subject.next(error)
        })
      return subject.pipe(
        map((response) => {
          if (response.data) {
            return loadPushNotifications(response.data, LOAD_PUSH_SMS_NOTIFICATIONS)
          } else {
            return failFetch(response)
          }
        })
      )
    })
  )
